import ClaimPage from '../../../src/client/pages/travel-insurance/components/make-a-claim';

export default ClaimPage;
